<template>
  <div id="app">
    <div class="header" v-if="showTopBottomView">
      <div class="headLeft">
        <img
          src="./assets/首页/白色小logo.png"
          class="logo"
          @click="homeClick()"
        />
        <button class="headBtn" @click="homeClick()">首页</button>
        <button class="headBtn" @click="appSquareClick()">应用广场</button>
        <button class="headBtn" @click="studyClick()">综合学习</button>
      </div>
      <div class="headRight" v-if="showSearch && !isMobile">
        <span v-if="showSearchIcon" class="iconfont icon-sousuo souso"></span>
        <input
          type="text"
          class="searchInput"
          @input="inputSearchValue"
          :value="searchValue"
          @focus="expandInput"
          @blur="collapseInput"
          @keyup.enter="searchAction()"
        />
        <p class="searchBtn" @click="searchAction()">搜索</p>
      </div>
    </div>
    <router-view />
    <div class="footer" v-if="showTopBottomView">
      <div class="bottomRow">
        <img src="./assets/首页/白色大logo.png" class="bottomIcon" />
        <div class="bottomRightRow">
          <p class="bottomStr" @click="callMe()">联系我们</p>
          <p class="bottomStr" @click="MailAction(1)">意见反馈</p>
          <p class="bottomStr" @click="MailAction(2)">友链申请</p>
        </div>
      </div>
      <p class="bottomDes">
        本站仅收录网站，不对其网站内容或交易负责。若收录的站点侵害到您的利益，请联系我们删除收录。邮箱：dev@ersanli.cn
      </p>
      <p class="bottomDes1">
        © 2020-2023 西安二三里网络科技有限公司 版权所有 陕ICP备17017925号-1
      </p>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      isMobile: this.detectMobile(), //是否是移动端
      showSearch: false,
      showTopBottomView: true,
      searchValue: "",
      showSearchIcon: true,
    };
  },
  created() {
    document.title = "MarsAI";
  },
  mounted() {},
  methods: {
    //判断是否是移动端
    detectMobile() {
      const userAgent = navigator.userAgent;
      return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
          userAgent
        ) && window.innerWidth < 768
      );
    },
    searchAction() {
      if (this.searchValue == "") {
        this.$message({
          message: "请输入搜索内容",
          type: "warning",
        });
      } else {
        const externalLink =
          window.location.origin +
          "/#/morearticle?searchValue=" +
          this.searchValue;
        console.log("externalLink=", externalLink);
        window.open(externalLink, "_blank");
        this.searchValue = "";
      }
    },
    expandInput() {
      // 输入框获得焦点时触发，你可以在这里添加其他逻辑
      this.showSearchIcon = false;
    },
    collapseInput() {
      // 输入框失去焦点时触发，你可以在这里添加其他逻辑
      this.showSearchIcon = true;
      // this.searchValue = "";
    },
    inputSearchValue(event) {
      this.searchValue = event.target.value;
    },
    studyClick() {
      this.$router.push({
        path: "/morearticle",
        query: { selectedID: 0 },
      });
    },
    appSquareClick() {
      this.$router.push({
        path: "/app",
      });
    },
    homeClick() {
      if (this.$route.path == "/") {
        window.location.reload();
      } else {
        this.$router.replace({
          path: "/",
        });
      }
    },
    //意见反馈和友链申请
    MailAction(type) {
      // 替换为你想要的收件人、主题和正文
      const to = "dev@ersanli.cn";
      let subject = "MarsAIGC_意见反馈";
      if (type == 2) {
        subject = "MarsAIGC_友链申请";
      }
      // 使用 mailto 协议生成邮件链接
      const mailtoLink = `mailto:${to}?subject=${encodeURIComponent(subject)}`;
      // 打开默认邮件客户端
      window.location.href = mailtoLink;
    },
    //联系我们
    callMe() {
      window.open("https://www.ersanli.cn/contact.html", "_blank");
    },
  },
};
</script>
<style lang="scss">
// 安卓
body {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
//IOS
i:focus,
a:focus,
input:focus,
p:focus,
div:focus {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  // -webkit-user-modify: read-write-plaintext-only; // 这个会出现输入图标，不需要
}

.header {
  // position: absolute;
  // left: 0px;
  // top: 0px;
  width: 100%;
  height: 68px;
  background-color: #000000;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.headLeft {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.headRight {
  margin-right: 50px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}
.logo {
  max-width: 51px;
  margin-left: 50px;
  cursor: pointer;
}
.headBtn {
  background-color: unset;
  border-style: none;
  margin-left: 40px;
  font-size: 18px;
  color: #ffffff;
  cursor: pointer;
}
.searchInput {
  width: 200px;
  height: 36px;
  border-radius: 18px;
  border-style: none;
  font-size: 18px;
  text-indent: 1em;
  transition: width 0.3s ease; /* 添加过渡效果 */
}
.searchInput:focus {
  width: 300px;
}
.searchBtn {
  font-size: 17px;
  color: #000000;
  margin-left: -50px;
  cursor: pointer;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}
body {
  margin: 0;
  padding: 0;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.bottomRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 75%;
  margin-top: 98px;
}
.bottomIcon {
  width: 191px;
}
.bottomRightRow {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.bottomStr {
  font-size: 14px;
  color: #ffffff;
  margin: 0px 33px;
  cursor: pointer;
}
.bottomDes {
  color: #ffffff;
  opacity: 0.4;
  font-size: 14px;
  line-height: 20px;
  margin-top: 108px;
}
.bottomDes1 {
  color: #ffffff;
  opacity: 0.4;
  font-size: 14px;
  line-height: 20px;
  margin-top: 10px;
}
.footer {
  background-color: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 350px;
  padding-bottom: 98px;
}
.souso {
  // margin-right: -40px;
  position: absolute;
  left: 20px;
  color: #000000;
  font-size: 20px !important;
}
@media screen and (max-width: 768px) {
  .el-message {
    min-width: 50% !important;
    p {
      font-size: 14px !important;
    }
  }
  .header {
    // position: absolute;
    // left: 0px;
    // top: 0px;
    width: 100%;
    height: 68px;
    background-color: #000000;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .headLeft {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .headRight {
    margin-right: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
  }
  .logo {
    max-width: 35px;
    margin-left: 10px;
    cursor: pointer;
  }
  .headBtn {
    background-color: unset;
    border-style: none;
    margin-left: 20px;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
  }
  .searchInput {
    width: 100px;
    height: 36px;
    border-radius: 18px;
    border-style: none;
    font-size: 18px;
    text-indent: 1em;
    transition: width 0.3s ease; /* 添加过渡效果 */
  }
  .searchInput:focus {
    width: 300px;
  }
  .searchBtn {
    font-size: 17px;
    color: #000000;
    margin-left: -50px;
    cursor: pointer;
  }
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: #2c3e50;
  }
  body {
    margin: 0;
    padding: 0;
  }

  nav {
    padding: 30px;

    a {
      font-weight: bold;
      color: #2c3e50;

      &.router-link-exact-active {
        color: #42b983;
      }
    }
  }
  .footer {
    display: flex;
    background-color: #000000;
    flex-direction: column;
    align-items: center;
    height: 240px;
    // padding-bottom: 98px;
  }
  .bottomRow {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    position: relative;
    width: 75%;
    margin-top: 20px;
  }
  .bottomIcon {
    width: 120px;
  }
  .bottomRightRow {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    height: 100%;
  }
  .bottomStr {
    font-size: 14px;
    color: #ffffff;
    margin: 0px 33px;
    cursor: pointer;
  }
  .bottomDes {
    color: #ffffff;
    opacity: 0.4;
    font-size: 13px;
    line-height: 20px;
    margin-top: 28px;
    text-align: center;
    width: 90%;
  }
  .bottomDes1 {
    color: #ffffff;
    opacity: 0.4;
    font-size: 13px;
    line-height: 20px;
    margin-top: 10px;
    text-align: center;
    width: 90%;
    margin-bottom: 10px;
  }
  .souso {
    // margin-right: -40px;
    position: absolute;
    left: 20px;
    color: #000000;
    font-size: 20px !important;
  }
}
</style>
